import { useTranslation } from 'react-i18next';

const Empty = () => {
  const { t } = useTranslation();
  return <div className="text-center"> {t('empty.text')}</div>;
};

export default Empty;
